import IsoStringConverter from '@migrate/utils/date/IsoStringConverter'
import { LocalDate, LocalDateTime, LocalTime, ZonedDateTime } from '@js-joda/core'
import LocalDateConverter from '@migrate/utils/date/LocalDateConverter'
import LocalDateTimeConverter from '@migrate/utils/date/LocalDateTimeConverter'
import LocalTimeConverter from '@migrate/utils/date/LocalTimeConverter'
import ZonedDateTimeConverter from '@migrate/utils/date/ZonedDateTimeConverter'
import NativeDateConverter from '@migrate/utils/date/NativeDateConverter'
import UsFormatStringConverter from '@migrate/utils/date/UsFormatStringConverter'
import LocalizedDateStringConverter from '@migrate/utils/date/LocalizedDateStringConverter'
import IlmFormatStringConverter from '@migrate/utils/date/IlmFormatStringConverter'

export const fromIsoString = (value: string) => new IsoStringConverter(value)
export const fromLocalDate = (value: LocalDate) => new LocalDateConverter(value)
export const fromUsFormat = (value: string) => new UsFormatStringConverter(value)
export const fromIlmFormat = (value: string) => new IlmFormatStringConverter(value)
export const fromLocalDateTime = (value: LocalDateTime) => new LocalDateTimeConverter(value)
export const fromZonedDateTime = (value: ZonedDateTime) => new ZonedDateTimeConverter(value)
export const fromLocalTime = (value: LocalTime) => new LocalTimeConverter(value)
export const fromNative = (value: Date) => new NativeDateConverter(value)
export const fromLocalizedString = (value: string) => new LocalizedDateStringConverter(value)

export const datePickerLabelFunc = (locale: string | string[]) => (date: Date | null) =>
  date ? fromLocalDate(fromNative(date).toLocalDate()).toLocalizedString(locale) : ''

export default class DateSupport {
  static DATE_FORMAT_DEFAULT: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }
}
